var chunkToChildrenMap = {
	"src_bootstrap_tsx-src_assets_images_home-page_knowledge-base_webp-src_assets_images_home-page-3466c3": [
		"Login"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };